import { t } from 'i18next'

import * as yup from 'yup'

import { IFormModel } from 'types'

/**
 * Form constants
 */
const IS_ENABLED = 'is_enabled'

/**
 * Form model
 */
const formModel = (): IFormModel => {
  return {
    [IS_ENABLED]: {
      label: `${t('common.active')}`,
      name: IS_ENABLED,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [IS_ENABLED]: false,
}

/**
 * Form data validation
 */
export const validationSchema = () => {}
export default formModel
